class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      // Art-Director R3 (28.09.2026): Dawn rollte das INLINE-Element <main-search> an die
      // Oberkante — das Feld landete bei top -59 / bottom -7 ueber dem Bildrand, man sah nur
      // noch die Vorschlagsliste, nicht, was man tippt. Jetzt rollt das Feld selbst, mit
      // scroll-margin-top (section-main-search.css) knapp unter die Oberkante.
      this.input.scrollIntoView({ block: 'start', behavior: 'smooth' });
      // Nachzug (R3, Nachmessung Vorschau 390): waehrend des Rollens klappt der Kopf weg und
      // der Inhalt rueckt 60 px nach — das Feld lag danach doch bei top -48. Steht es nach
      // dem Rollen nicht ganz im Bild, rollt die Seite zurueck, bis es UNTER dem Kopf steht:
      // Rollen nach oben blendet den klebenden Kopf wieder ein (erster Nachzug lag darunter).
      window.clearTimeout(this.apNachzug);
      this.apNachzug = window.setTimeout(() => {
        const r = this.input.getBoundingClientRect();
        if (r.top >= 4 && r.bottom <= window.innerHeight) return;
        const kopf = document.querySelector('.section-header');
        const frei = (kopf ? kopf.offsetHeight : 0) + 12;
        window.scrollBy({ top: r.top - frei, behavior: 'smooth' });
      }, 700);
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
